import { render, staticRenderFns } from "./PageContentLayout.vue?vue&type=template&id=f3975ebc&"
import script from "./PageContentLayout.vue?vue&type=script&lang=js&"
export * from "./PageContentLayout.vue?vue&type=script&lang=js&"
import style0 from "./PageContentLayout.vue?vue&type=style&index=0&id=f3975ebc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports